/**
 * to store the order details of reaction set
 */
export class OrderDetails {
    orderId: string;
    orderItemId: string;
}